import React from 'react'

const APPSTORE_IMG = '/img/AppStore.png'
const PLAYSTORE_IMG = '/img/PlayStore.png'

/* React Components */
const StoreImagelinks = ({ ios_link, goog_link }) => (
  <div className="stores">
    <a href={ios_link} target="_blank" rel="noopener noreferrer">
      <img src={APPSTORE_IMG} alt="Apple Appstore" />
    </a>
    <a href={goog_link} target="_blank" rel="noopener noreferrer">
      <img src={PLAYSTORE_IMG} alt="Google Play Store" />
    </a>
  </div>
)

export default StoreImagelinks
